import {
  GET_SKILLS_FAIL,
  GET_SKILLS_START,
  GET_SKILLS_SUCCESS,
  GET_USER_SKILLS_FAIL,
  GET_USER_SKILLS_START,
  GET_USER_SKILLS_SUCCESS,
} from './constants';

const initialState = {
  skills: null,
  userSkills: null,
  isLoading: false,
};

// eslint-disable-next-line
export default (state = initialState, { type, response, headers }) => {
  switch (type) {
    case GET_USER_SKILLS_START:
      return {
        ...state,
        isLoading: true,
      };

    case GET_USER_SKILLS_SUCCESS:
      return {
        ...state,
        userSkills: response,
        isLoading: false,
      };

    case GET_USER_SKILLS_FAIL:
      return { ...state, isLoading: false };

    case GET_SKILLS_START:
      return {
        ...state,
        isLoading: true,
      };

    case GET_SKILLS_SUCCESS:
      return {
        ...state,
        skills: response?.content,
        isLoading: false,
      };

    case GET_SKILLS_FAIL:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
